import axios from 'axios';
import { ApiResponse } from '../Interfaces/AxiosResponse';

class AxiosUtil {
    static async get<T, Q extends Record<string, any>>(
        url: string,
        queryParams: Q
    ): Promise<T> {
        // Filter out empty arrays from query parameters
        const arrayEmptyFilteredQueryParams = Object.entries(queryParams).filter(
            ([_, value]) => !(Array.isArray(value) && value.length === 0)
        );
        //.reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});

        // expand values that happen to be arrays:  param1=value1&param1=value2 etc.
        let arrayExpandedFilteredQueryParams: string[][] = [];
        
        arrayEmptyFilteredQueryParams.forEach( x => {
            if (Array.isArray(x[1])){
                x[1].forEach( y => {
                    arrayExpandedFilteredQueryParams.push([x[0], y]);
                })
            }
            else{
                arrayExpandedFilteredQueryParams.push(x);
            }
        });

        // convert to query string
        const queryString = new URLSearchParams(
            arrayExpandedFilteredQueryParams as any
        ).toString();

        try {
            const response: ApiResponse<T> = await axios.get(
                `${url}?${queryString}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async post<T, Q extends Record<string, any>>(
        url: string,
        body: Q
    ): Promise<T> {
        try {
            const response: ApiResponse<T> = await axios.post(url, body);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default AxiosUtil;
